import { isEmpty } from 'lodash';

export default {
  hasTreatmentPlanSettings: (state) => {
    return !isEmpty(state.clinicTreatmentAreas);
  }, // hasTreatmentPlanSettings()
};
